import React from 'react';
import ReactDOM from 'react-dom';
import "typeface-open-sans";
import './index.css';
import './shared/Icons.css';
import ClientApp from './ClientApp';
import localConfig from './localConfig';

import URLSearchParams from 'url-search-params';

import values from 'object.values';

import openSocket from 'socket.io-client';

import { IntlProvider, addLocaleData } from 'react-intl';
import de from 'react-intl/locale-data/de';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';
import en from 'react-intl/locale-data/en';

import messages_de from './shared/translations/messages_de.json';
import messages_fr from './shared/translations/messages_fr.json';
import messages_it from './shared/translations/messages_it.json';
import messages_en from './shared/translations/messages_en.json';

const localeData = {
  de: messages_de,
  fr: messages_fr,
  it: messages_it,
  en: messages_en
}

const config = Object.assign({}, window.config, localConfig);

addLocaleData([...de, ...fr, ...it, ...en]);

const languages = ['en'];

let setting = window.localStorage ? window.localStorage.getItem('language') : null;
let language = (navigator.languages && navigator.languages[0]) ||
                     navigator.language ||
                     navigator.userLanguage;
let languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

setting = languages.indexOf(setting) === -1 ? null : setting;
language = languages.indexOf(language) === -1 ? null : language;
languageWithoutRegionCode = languages.indexOf(languageWithoutRegionCode) === -1 ? null : languageWithoutRegionCode;

const messages = localeData[setting] || localeData[languageWithoutRegionCode] || localeData[language] || localeData.en;

if (!Object.values) {
	values.shim();
}

const iceServers = config.nextcare.iceServers;

const socket = openSocket(config.nextcare.commServer, {
  rememberTransport: true, 
  'reconnection': true,
  'reconnectionDelay': 500,
  'secure': true,
  'pingTimeout': 20000
});

const appLinks = {
  'ios': 'https://apps.apple.com/us/app/nextcare-pro/id1500550936'
};

// const socket = openSocket('https://localhost:443');
const params = new URLSearchParams(document.location.search);
let locale = localeData[setting] ? setting : localeData[languageWithoutRegionCode] ?  languageWithoutRegionCode : localeData[language] ? language : 'de';

ReactDOM.render(
  <IntlProvider locale={locale} messages={messages}>
    <ClientApp
      jitsiConfig={config}
      config={config}
      iceServers={iceServers}
      locale={locale}
      appLinks={appLinks}
      socket={socket}
      sharedqueue={params.get('sq')}
      name={params.get('n')}
      user={params.get('u')}
      appointment={params.get('a') ? new Date(parseInt(params.get('a'), 10)) : null}
      group={params.get('g') ? atob(params.get('g')) : null}
    />
  </IntlProvider>,
document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js